import React from "react";
import { NavItem } from "reactstrap";

//Common
import { MoreActionsMenu } from "../common/MoreActionsMenu";
import { ResendIcon, LockIcon, ResetIcon } from "../common/Icons";
import useMoreActionsMenuStyles from "../common/MoreActionsMenu/styles";

//App
import { UserMoreActionsMenuProps } from "../../types";

const UserMoreActionsMenu: React.FC<UserMoreActionsMenuProps> = (props) => {
  const {
    onPermissionClick,
    onResendVerificationClick,
    onUnlockUserClick,
    onResetPasswordClick,
    ...restProps
  } = props;

  const moreActionMenuStyles = useMoreActionsMenuStyles();

  return (
    <MoreActionsMenu {...restProps}>
      {onPermissionClick && (
        <NavItem
          style={moreActionMenuStyles.navItem}
          onClick={onPermissionClick}
        >
          <LockIcon />
        </NavItem>
      )}
      {onResendVerificationClick && (
        <NavItem
          style={moreActionMenuStyles.navItem}
          onClick={onResendVerificationClick}
        >
          <ResendIcon />
        </NavItem>
      )}
      {onUnlockUserClick && (
        <NavItem
          style={moreActionMenuStyles.navItem}
          onClick={onUnlockUserClick}
        >
          <LockIcon iconText="Unlock Account" />
        </NavItem>
      )}
      {onResetPasswordClick && (
        <NavItem
          style={moreActionMenuStyles.navItem}
          onClick={onResetPasswordClick}
        >
          <ResetIcon />
        </NavItem>
      )}
    </MoreActionsMenu>
  );
};

export default UserMoreActionsMenu;
